import useMap from "../../components/useMap";
import useSelectedFeatures from "../../components/maps/GeoJSONMap/useSelectedFeatures";
import {useGeoJSONIncidents} from "../../components/maps/query";


const useIncidentMap = ({incidentsFilters}) => {
    const geoIncidentsQuery = useGeoJSONIncidents(incidentsFilters);
    const incidentsGeoJSON = geoIncidentsQuery.data ?? {type: "FeatureCollection", features: []}
    const map = useMap();
    const selectedFeatures = useSelectedFeatures({features: incidentsGeoJSON.features});

    return {
        geoJSON: incidentsGeoJSON,
        ...map,
        ...selectedFeatures,
    }
}


export default useIncidentMap;